module.exports = __webpack_public_path__ + "static/media/slick.d41f55a7.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/slick.ttf
// module id = 341
// module chunks = 0